var map = {
	"./menu_0.png": "9ddf",
	"./menu_1.png": "3f57",
	"./menu_10.png": "43cd",
	"./menu_12.png": "c16f",
	"./menu_13.png": "e208",
	"./menu_2.png": "826c",
	"./menu_3.png": "52da",
	"./menu_4.png": "3791",
	"./menu_5.png": "afc9",
	"./menu_6.png": "e4d0",
	"./menu_7.png": "9b9d",
	"./menu_8.png": "bc41",
	"./menu_9.png": "7fbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3881";